export default () => ({
  orderConfirmationResponse: null,
  isSerialRmaAssociated: null,
});
